import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { GooglePlaceDirective } from "./google-place.directive";

@NgModule({
  imports: [CommonModule],
  declarations: [GooglePlaceDirective],
  exports: [GooglePlaceDirective],
})
export class GooglePlaceModule {}
